// Escopo do cache do React Query POR conta logada.
//
// Problema: as queryKeys nao incluem o id da conta (ex.: ["prefeitura","dashboard"]),
// entao ao trocar de conta a query encontrava o cache da conta ANTERIOR e mostrava
// os dados dela por alguns segundos (vazamento entre contas).
//
// Solucao anterior (qc.clear() no login) resolvia o vazamento, mas esvaziava TODO
// o cache — cada primeira visita a uma tela passava a buscar do zero ("Carregando"
// em todo menu). Aqui a gente escopa o HASH do cache com a conta atual: contas
// diferentes viram entradas de cache diferentes (sem vazamento) e voltar pra uma
// conta ja visitada reaproveita o cache dela (sem delay). Ver main.tsx
// (queryKeyHashFn) e login.tsx (setAccountKey no login).

const STORAGE_KEY = "atlas:acct";

let _acct = "";
try { _acct = window.localStorage.getItem(STORAGE_KEY) ?? ""; } catch { /* sem storage */ }

/**
 * Normaliza o identificador digitado no login numa chave ESTÁVEL.
 *
 * O campo "CPF ou e-mail" é texto livre, sem máscara: a mesma pessoa entra
 * hoje com `593.093.358-05` e amanhã com `59309335805`. Os dois logam, mas
 * como chave de conta são strings diferentes — e tudo que é escopado por
 * conta (cache do React Query e, desde 13/08/2026, o estado de lido das
 * notificações) passaria a se comportar como se fosse outro usuário.
 *
 * CPF vira só dígitos; e-mail vira minúsculas sem espaço. Sem identificador,
 * cai no papel, como antes.
 */
export function normalizarConta(identifier: string, role: string): string {
  const limpo = identifier.trim().toLowerCase();
  if (!limpo) return role;
  const digitos = limpo.replace(/\D/g, "");
  return digitos.length === 11 ? digitos : limpo;
}

/** Define a conta atual (chamado no login). Persiste pra sobreviver a F5. */
export function setAccountKey(key: string): void {
  _acct = key;
  try { window.localStorage.setItem(STORAGE_KEY, key); } catch { /* ignore */ }
}

/** Limpa a conta atual (chamado no logout). */
export function clearAccountKey(): void {
  _acct = "";
  try { window.localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
}

/** Conta atual — prefixo do hash de cache. Vazio quando deslogado. */
export function accountKey(): string {
  return _acct;
}
